import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    mountProject: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to mount a project */
            mountProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OpenOnDesktopMenuButton.mountProject?c=st41s5g1s476", defaultMessage: "Open on Desktop" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
